<template>
  <div>
    <div
      class="form-detail"
      v-if="dataContract.lstAppendixHandOvers && dataContract.lstAppendixHandOvers.length > 0"
    >
      <h1>Biên bản bàn giao</h1>
      <div
        class="table-responsive"
        v-for="(item, index) in dataContract.lstAppendixHandOvers"
        :key="index"
      >
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th scope="col" class="text-left">Mã biên bản</th>
              <th scope="col" class="text-left">Thời gian</th>
              <th scope="col" class="text-left">Số lượng thiết bị</th>
              <th scope="col" class="text-right">Trạng thái</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-row">
              <td align="left">{{ item.code }}</td>
              <td align="left">
                <p v-if="item.dateCreate">
                  <b>Ngày tạo: </b>{{ item.dateCreate | formatDate('HH:mm DD/MM/YYYY') }}
                </p>
                <p
                  v-if="
                    item.state &&
                    (item.state === 'SIGNED_WAITING_APPROVED' || item.state === 'REJECTED_SA') &&
                    item.dateSign
                  "
                >
                  <b>Ngày ký :</b> {{ item.dateSign | formatDate }}
                </p>
                <p v-if="item.state && item.state === 'CANCELED'">
                  <b>Ngày huỷ :</b> {{ item.dateCancel | formatDate }}
                </p>
              </td>
              <td class="text-left">
                {{ item.numDevices ? item.numDevices : item.appendixHandOver.deviceRecalls.length }}
              </td>
              <td align="right">
                <span class="badge" :class="[item.state ? item.state : '']">
                  {{ item.state ? item.state : '' | mapTextStatus(listStatusContract) }}
                </span>
                <div
                  v-if="
                    item.state && (item.state === 'REJECTED_SA' || item.state === 'REJECTED_MA')
                  "
                >
                  <p
                    v-if="
                      item.reasonRejected && item.reasonRejected[item.reasonRejected.length - 1]
                    "
                    class="form-control-plaintext f12 text-center"
                  >
                    Lý do: &nbsp;
                    {{
                      item.reasonRejected ? item.reasonRejected[item.reasonRejected.length - 1] : ''
                    }}
                  </p>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="6">
                <table class="table table-bordered">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col" class="text-left">Tên thiết bị</th>
                      <th scope="col" class="text-left">Mã serial</th>
                      <th scope="col" class="text-right">Giá</th>
                    </tr>
                  </thead>
                  <tbody v-for="(itemm, index) in item.appendixHandOver.devices" :key="index">
                    <tr class="table-row">
                      <td class="text-left">{{ itemm.displayName }}</td>
                      <td class="text-left">{{ itemm.serialNumber }}</td>
                      <td align="right">{{ itemm.price | fomatCurrency }}</td>
                    </tr>
                  </tbody>
                </table>
                <span
                  >Lý do bàn giao:
                  {{
                    item.appendixHandOver.handOverReason
                      ? item.appendixHandOver.handOverReason
                      : '' | transformData(Config.reasonHandOver)
                  }}</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'

  export default {
    props: ['dataContract'],
    data() {
      return {
        Config,
        listStatusContract: Config.listStatusContract,
      }
    },
    methods: {},
  }
</script>
